import React from "react";
import { Typography, Card } from "antd";

const { Title, Paragraph } = Typography;

const TermsOfUse = () => {
  return (
    <div className="min-h-screen bg-[#f7fafc] py-10 px-4">
      <div className="max-w-4xl mx-auto">
        <Card className="rounded-xl shadow-sm border border-gray-100">
          <Typography className="[&_.ant-typography]:!mb-2 [&_.ant-typography]:!mt-0">
            <Title level={2} className="!text-[#1c5a85] !mb-1">
              Terms of Use for Eye on Wellness
            </Title>

            <Paragraph className="mt-6">
              Welcome to Eye on Wellness. By downloading, accessing, or using our
              website, you agree to these Terms of Use. If you do not agree, please do
              not use the platform.
            </Paragraph>

            <Title level={4}>1. Use of the App/Website</Title>
            <Paragraph>
              Eye on Wellness provides wellness-related insights based on
              user-submitted information, including iris images. This is intended for
              informational and educational purposes only. You agree to use the
              app/website only for lawful purposes and in accordance with these Terms.
            </Paragraph>

            <Title level={4}>2. Not Medical Advice</Title>
            <Paragraph>Eye on Wellness does not provide medical advice.</Paragraph>
            <Paragraph>
              All content, reports, and insights are:
              <br />
              For educational purposes only
              <br />
              Not intended to diagnose, treat, cure, or prevent any disease
            </Paragraph>
            <Paragraph>
              You should always consult a qualified healthcare provider for medical
              concerns. All supplements are suggestions. You may or may not agree with
              suggestions and that is why they are suggestions.
            </Paragraph>

            <Title level={4}>3. User Accounts</Title>
            <Paragraph>
              To access certain features, you may be required to create an account.
            </Paragraph>
            <Paragraph>
              You agree to:
              <br />
              Provide accurate information
              <br />
              Maintain the security of your login credentials
              <br />
              Accept responsibility for all activity under your account
            </Paragraph>

            <Title level={4}>4. Subscriptions &amp; Payments</Title>
            <Paragraph>Certain features require a paid subscription.</Paragraph>
            <Paragraph>
              <strong>Subscription Details:</strong>
              <br />
              Subscriptions are billed through stripe.
              <br />
              Payment is charged on card provided every account at confirmation of
              purchase
              <br />
              Subscriptions automatically renew unless canceled at least 24 hours
              before the end of the current billing period
              <br />
              Your account will be charged for renewal within 24 hours prior to the
              end of the current period
            </Paragraph>
            <Paragraph>
              <strong>Managing Subscriptions:</strong>
              <br />
              You can manage or cancel your subscription inside website. We do not
              store or have access to your payment information.
            </Paragraph>

            <Title level={4}>5. Intellectual Property</Title>
            <Paragraph>
              All content within the site, including text, design, graphics, and
              reports, is owned by Eye on Wellness or its licensors and is protected
              by intellectual property laws.
            </Paragraph>
            <Paragraph>
              You may not:
              <br />
              Copy, reproduce, or distribute content without permission
              <br />
              Use the app/website for commercial purposes without authorization
            </Paragraph>

            <Title level={4}>6. User Content</Title>
            <Paragraph>
              By submitting images or data through the app or website, you grant us a
              limited license to use that content solely for the purpose of providing
              the app/website services.
            </Paragraph>

            <Title level={4}>7. Limitation of Liability</Title>
            <Paragraph>
              To the fullest extent permitted by law, Eye on Wellness is not liable
              for:
              <br />
              Any decisions made based on the app&apos;s content or its content.
              <br />
              Any indirect, incidental, or consequential damages.
              <br />
              Any inaccuracies in reports or insights. This is for educational purposes
              only use at you on discretion.
            </Paragraph>
            <Paragraph>Use of the app/website is at your own risk.</Paragraph>

            <Title level={4}>8. Termination</Title>
            <Paragraph>
              We may suspend or terminate access to the app/website access at any time
              if you violate these Terms.
            </Paragraph>

            <Title level={4}>9. Changes to Terms</Title>
            <Paragraph>
              We may update these Terms from time to time. Continued use of the
              app/website after changes means you accept the updated Terms.
            </Paragraph>

            <Title level={4}>10. Governing Law</Title>
            <Paragraph>
              These Terms shall be governed by and interpreted in accordance with the
              laws of United States and every state therein.
            </Paragraph>

            <Title level={4}>11. Contact Information</Title>
            <Paragraph>
              If you have any questions about these Terms, please contact us:
              <br />
              Email:{" "}
              <a href="mailto:wellnessmel869@gmail.com">wellnessmel869@gmail.com</a>
              <br />
              Company Name: Eye On Wellness
            </Paragraph>
          </Typography>
        </Card>
      </div>
    </div>
  );
};

export default TermsOfUse;
